export class StringUtil {
    
    public static startWith (origin : string, compare : string) : boolean {
        var isIndexOf = (origin.indexOf(compare) == 0);
        return isIndexOf;
    }
}


// WEBPACK FOOTER //
// C:/Users/sung/WebstormProjects/exafe front/src/app/utility/StringUtil.ts